<template>
    <div>
        <v-toolbar flat color="white">
            <v-btn color="primary" round @click="addItem()">Add</v-btn>
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="search"></v-text-field>
        </v-toolbar>
        <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="vehicles"
      item-key="id"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon small @click="updateItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteVehicle(props.item)">delete</v-icon>

        </td>
        <td
          class="text-xs-center"
        >{{props.item.make}}</td>
        <td
          class="text-xs-center"
        >{{props.item.model}}</td>
        <td
          class="text-xs-center"
        >{{props.item.year}}</td>
        <td
          class="text-xs-center"
        >{{props.item.registration}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

        <v-dialog v-model="addModal" width="500px">
            <v-card flat v-if="item">
                <v-toolbar color="primary">
                    <h3 class="white--text">{{item.type}} Vehicle</h3>
                    <v-spacer></v-spacer>
                    <v-btn color="white" flat @click="addModal=false, item=null">X</v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-text-field label="Make" placeholder="eg Volkswagen, Ford etc" v-model="item.make"></v-text-field>
                    <v-text-field label="Model" placeholder="eg Ranger, Polo" v-model="item.model"></v-text-field>
                    <v-text-field label="Year" v-model="item.year"></v-text-field>
                    <v-text-field label="License Plate Number" v-model="item.registration"></v-text-field>

                </v-card-text>
                <v-card-actions>
                    <v-layout justify-center>
                        <v-btn v-if="item.type=='Add' && item.make &&item.model&&item.year&&item.registration" round color="primary" class="white--text" @click="createVehicle(item)">Save</v-btn>
                        <v-btn v-else-if="item.type=='Edit' && item.make &&item.model&&item.year&&item.registration" round color="primary" class="white--text" @click="updateVehicle(item)">Save</v-btn>
                        <v-btn v-else disabled round>Save</v-btn>

                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        </div>
</template>
<script>
import Api from '@/services/Api'
export default {
    data(){
        return {
            addModal: false,
            headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Make",
          align: "center",
          value: "make"
        },
        {
          text: "Model",
          align: "center",
          value: "model"
        },
        {
          text: "Year",
          align: "center",
          value: "year"
        },
        {
          text: "Licence Plate Number",
          align: "center",
          value: "registration"
        }
      ],
            item: null,
            search: '',
            vehicles: []
        }

    },
    created(){
this.fetchVehicles()
    },
    methods: {
        addItem(){
            if(this.authCreate(this.$store.state.currentRoute)){
                this.item = {
                    type: 'Add',

                }
                this.addModal = true
            }
        },
        updateItem(item){
            if(this.authUpdate(this.$store.state.currentRoute)){
                this.item = item
                this.item.type='Edit'
                this.addModal = true
            }
        },
        createVehicle(item){
            Api().post('/vehicle', item).then(res=>{
                this.fetchVehicles()
                this.item={}
                this.addModal=false
            })
        },
        fetchVehicles(){
            Api().get('/vehicle').then(res=>{
                this.vehicles = res.data
            })
        },
        deleteVehicle(item){
            if(this.authDelete(this.$store.state.currentRoute)){
            confirm('Are you sure you want to delete this vehicle?')&&
            Api().put('/vehicle/'+item.id, {isActive: false, isDeleted: true}).then(res=>{
                this.fetchVehicles()
            })
            }
        },
        updateVehicle(item){
            Api().put('/vehicle/'+item.id, item).then(res=>{
                this.fetchVehicles()
                this.item={}
                this.addModal=false
            })
        },
    }
}
</script>